<template>
  <el-row justify="space-between" :gutter="20" s>
    <div style="margin:5px 10px;width:100%;box-shadow: 2px 2px 2px #c4c3c3;background-color: #eeeeee;height: 40px;align-items: center;display: flex;align-content: center">
      <div style="font-size: 20px;font-weight: bold;margin: 5px;display: inline-flex;align-items: center">
        <svg class="icon" style="margin-right: 10px;width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1503"><path d="M384 16.128v133.7216C234.8544 202.5664 128 344.8064 128 512c0 212.0768 171.9232 384 384 384 167.1936 0 309.44-106.8544 362.1504-256h133.7216c-56.8384 220.832-257.2992 384-495.872 384-282.7712 0-512-229.2288-512-512C0 273.4272 163.168 72.9664 384 16.128zM512 0c282.7712 0 512 229.2288 512 512H512V0z" fill="#4A4A4A" p-id="1504"></path></svg>
        TF binding
      </div>
    </div>
    <el-col :span="12">
      <el-form
          :model="form"
          label-width="auto"
          :label-position="'top'"
          style="max-width: 600px;font-weight: bolder;font-size: 15px;margin-top: 20px">

<!--        <el-form-->
<!--            :model="form.asm"-->
<!--            :inline="true"-->
<!--            :label-position="'left'"-->
<!--            style="max-width: 600px;font-weight: bolder;font-size: 15px;margin-top:10px;"-->
<!--            label-width="auto">-->
          <el-form-item label="">
            <el-radio-group v-model="form.type" @change="handleAnalysisTypeChange">
              <el-radio label="tf">TF</el-radio>
              <el-radio label="snv">SNV</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" v-if="form.type === 'snv'">
            <el-input
                v-model="form.snv"
                placeholder="Please input SNV (e.g. rs1883832)"
                clearable
                style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="" v-if="form.type === 'tf'">
            <el-autocomplete
                v-model="form.tf"
                :fetch-suggestions="querySearch"
                clearable
                class="inline-input w-50"
                style="width: 100%;"
                placeholder="Please input a TF name "
                @select="handleSelect"
            />
          </el-form-item>

          <el-form-item label="ASM Tissue">
            <el-select v-model="form.asm.tissue" placeholder="Select" style="width: 100%">
              <el-option
                  v-for="item in tissueOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
<!--        </el-form>-->
        <el-form-item label="ASM sample type">
          <el-checkbox-group v-model="form.health_status">
            <el-checkbox label="Cancer" value="Cancer" />
            <el-checkbox label="Normal" value="Normal" />
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="Motif source">
          <el-radio-group v-model="form.motif" style="width: 200px;">
            <el-radio value="Jspar_validated">
              <div style="display: inline-flex;align-items: center">
              <span style="margin-right: 10px">Jspar validated</span>
              <el-tooltip
                  class="box-item"
                  effect="light"
                  :content="'<p style=\'width: 400px;\'>Motifs in the JASPAR database that are derived from published literature and supported by experimental evidence.</p>'"
                  raw-content
                  placement="left"
              >
                <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
              </el-tooltip>
              </div>
            </el-radio>
            <el-radio value="Jspar_predicted">
              <div style="display: inline-flex;align-items: center">
                <span style="margin-right: 10px">Jspar predicted</span>
                <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="'<p style=\'width: 400px;\'>Unvalidated motifs in the JASPAR database.</p>'"
                    raw-content
                    placement="left"
                >
                  <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
            </el-radio>
            <el-radio value="HOCOMOCOv12core">
              <div style="display: inline-flex;align-items: center">
                <span style="margin-right: 10px">Hocomoco v12 core</span>
                <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="'<p style=\'width: 400px;\'>Motifs in the HOCOMOCO database (v12) curated and benchmarked for high accuracy.</p>'"
                    raw-content
                    placement="left"
                >
                  <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
              </el-radio>
            <el-radio value="HOCOMOCOv12invitro">
              <div style="display: inline-flex;align-items: center">
                <span style="margin-right: 10px">Hocomoco v12 invitro</span>
                <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="'<p style=\'width: 400px;\'>Motifs in the HOCOMOCO database (v12) derived from controlled experimental conditions, such as HT-SELEX, conducted in vitro.</p>'"
                    raw-content
                    placement="left"
                >
                  <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
              </el-radio>
            <el-radio value="HOCOMOCOv12invivo">
              <div style="display: inline-flex;align-items: center">
                <span style="margin-right: 10px">Hocomoco v12 invivo</span>
                <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="'<p style=\'width: 400px;\'>Motifs in the HOCOMOCO database (v12) identified from experiments, such as ChIP-Seq, conducted in vivo.</p>'"
                    raw-content
                    placement="left"
                >
                  <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
              </el-radio>
            <el-radio value="HOCOMOCOv12rSNP">
              <div style="display: inline-flex;align-items: center">
                <span style="margin-right: 10px">Hocomoco v12 rSNP</span>
                <el-tooltip
                    class="box-item"
                    effect="light"
                    :content="'<p style=\'width: 400px;\'>Motifs optimized by the HOCOMOCO database (v12) for detecting altered TF binding at regulatory single nucleotide variants.</p>'"
                    raw-content
                    placement="left"
                >
                  <el-icon style="color: #107fe7;font-size: 20px"><QuestionFilled /></el-icon>
                </el-tooltip>
              </div>
            </el-radio>
          </el-radio-group>
        </el-form-item>
<!--        </el-form>-->
        <el-form-item>
          <el-button type="success" @click="onSubmit">Submit</el-button>
          <el-button type="danger" @click="ReSet">Reset</el-button>
          <el-button type="primary" @click="Example2">Example1</el-button>
          <el-button type="primary" @click="Example1">Example2</el-button>
        </el-form-item>
      </el-form>
      <div style="">
        <h2 style="">Introduction</h2>
<!--        <h3 style="color: red">Distal regulation:</h3>-->
        <p style="text-align: justify;line-height: 20px">
          TF or SNV: Users can input a specific TF name to evaluate changes in its binding affinity caused by index SNVs using PFMs and to obtain colocalized index SNVs. Alternatively, they can input a specific SNV to identify all affected TFs. Notably, if a TF is input, the tool also provides an analysis of the correlation between changes in binding affinity and methylation levels of paired CpGs influenced by ASMs across all samples.
          ASM tissue & ASM sample type: Filter the candidate ASMs to be analyzed, including the sample types and the tissue of the samples where ASM occurs.
        </p>
<!--        <h3 style="color: red">Proximal regulation:</h3>-->
<!--        <p style="text-align: justify;line-height: 20px">-->
<!--          ASM tissue & ASM sample type: Filter the candidate ASMs to be analyzed, including the sample types where ASM occurs and the tissue types of the samples.-->
<!--        </p>-->
        <p style="text-align: justify;line-height: 20px">
          Motif source: Select the motif sources to be used for analyzing TF affinity changes.
        </p>
      </div>
    </el-col>
<!--    <el-divider direction="vertical" border-style="color: #c4c3c3;font-size: 1px;height:100%"/>-->
    <el-col :span="12">
<!--      <div style="box-shadow: 2px 2px 2px #c4c3c3;background-color: #eeeeee;margin: 5px 0;height: 40px;align-items: center;display: flex;align-content: center">-->
<!--        <div style="font-size: 20px;font-weight: bold;margin: 5px">Schematic diagram of the function</div>-->
<!--      </div>-->
      <div style="text-align: center">
        <img src="@/assets/analysis/TF_binding.png" height="742" width="631"/>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { reactive,ref,onMounted,toRefs } from 'vue'
import {useRouter} from "vue-router";
export default {
  name: "analysis_page",
  setup(){
    const router = useRouter()
    const p = [10**(-6),10**(-5),10**(-4),10**(-3),10**(-2)]
    const form = reactive({
      type: 'tf', // 默认选择TF分析
      tf: '',
      snv: '',
      asm: {
        tissue: '',
      },
      p:{
        p_value: '',
      },
      health_status: [],
      motif: '',
    })
    const data = reactive({
      tissueOptions:[
        {name:'ALL',value:'ALL'},
        {name:'Bladder',value:'Bladder'},
        {name:'Blood',value:'Blood'},
        {name:'Bone marrow',value:'Bone marrow'},
        {name:'Brain',value:'Brain'},
        {name:'Breast',value:'Breast'},
        {name:'Breast  cancer pdx model',value:'Breast  cancer pdx model'},
        {name:'Cartilage',value:'Cartilage'},
        {name:'Cervix',value:'Cervix'},
        {name:'Esophagus',value:'Esophagus'},
        {name:'Gastric',value:'Gastric'},
        {name:'Intestine',value:'Intestine'},
        {name:'Kidney',value:'Kidney'},
        {name:'Liver',value:'Liver'},
        {name:'Lung',value:'Lung'},
        {name:'Lymph  node',value:'Lymph  node'},
        {name:'Nasopharynx',value:'Nasopharynx'},
        {name:'Nipple  aspirate fluid',value:'Nipple  aspirate fluid'},
        {name:'Oral  ',value:'Oral  '},
        {name:'Ovary',value:'Ovary'},
        {name:'Pancreas',value:'Pancreas'},
        {name:'PDX model colorectal cancer ',value:'PDX model colorectal cancer '},
        {name:'PDX of prostate cancer',value:'PDX of prostate cancer'},
        {name:'Peritoneum',value:'Peritoneum'},
        {name:'Plasma',value:'Plasma'},
        {name:'Prostate',value:'Prostate'},
        {name:'Retina',value:'Retina'},
        {name:'Retinal organoids',value:'Retinal organoids'},
        {name:'Skin',value:'Skin'},
        {name:'Thyroid gland',value:'Thyroid gland'},
        {name:'Xenograft cells of acute lymphoblastic leukemia',value:'Xenograft cells of acute lymphoblastic leukemia'}
      ],
      p_valueOptions: [
        {value: p[0].toExponential(0).toString() ,label: p[0].toExponential(0).toString()},
        {value: p[1].toExponential(0).toString() ,label: p[1].toExponential(0).toString()},
        {value: p[2].toExponential(0).toString() ,label: p[2].toExponential(0).toString()},
        {value: p[3].toExponential(0).toString() ,label: p[3].toExponential(0).toString()},
        {value: p[4].toExponential(0).toString() ,label: p[4].toExponential(0).toString()},
        {value: '0.05' ,label: '0.05'}
      ]
    })
    const onSubmit = () => {
      var formJson = JSON.stringify(form)
      router.push({
        path:"/TF_binding_analysis/detail",
        query:{
          form: formJson
        }
      })
    }
    const Example1 = () => {
      form.type = 'snv'
      form.tf = ''
      form.snv = 'rs1883832'
      form.asm.tissue = "Skin"
      form.health_status = ['Cancer','Normal']
      form.motif = 'Jspar_validated'
    }
    const Example2 = () => {
      form.type = 'tf'
      form.tf = 'OTX1'
      form.snv = ''
     form.asm.tissue = "Blood"
      form.health_status = ['Cancer','Normal']
      form.motif = 'Jspar_validated'
    }
    const ReSet = () => {
      form.type = 'snv'
      form.tf = ''
      form.snv = ''
      form.asm.tissue = {}
      form.health_status = []
      form.motif = ''
    }
    // 自动填充
    const restaurants = ref([])
    const querySearch = (queryString, cb) => {
      const results = queryString
          ? restaurants.value.filter(createFilter(queryString))
          : restaurants.value
      // call callback function to return suggestions
      cb(results)
    }
    const createFilter = (queryString) => {
      return (restaurant) => {
        return (
            restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    }
    const loadAll = () => {
      return [
        {value:'AHR'}
          ,{value:'AHRR'}
          ,{value:'ALX1'}
          ,{value:'ALX3'}
          ,{value:'ALX4'}
          ,{value:'ANDR'}
          ,{value:'AP2A'}
          ,{value:'AP2B'}
          ,{value:'AP2C'}
          ,{value:'AP2E'}
          ,{value:'ARGFX'}
          ,{value:'ARI1A'}
          ,{value:'ARNT'}
          ,{value:'ARNT2'}
          ,{value:'ARX'}
          ,{value:'ASCL1'}
          ,{value:'ASCL2'}
          ,{value:'ATF1'}
          ,{value:'ATF2'}
          ,{value:'ATF3'}
          ,{value:'ATF4'}
          ,{value:'ATF6A'}
          ,{value:'ATF6B'}
          ,{value:'ATF7'}
          ,{value:'ATOH1'}
          ,{value:'ATOH8'}
          ,{value:'BACH1'}
          ,{value:'BACH2'}
          ,{value:'BARH1'}
          ,{value:'BARH2'}
          ,{value:'BARX1'}
          ,{value:'BARX2'}
          ,{value:'BATF'}
          ,{value:'BATF3'}
          ,{value:'BCL6'}
          ,{value:'BCL6B'}
          ,{value:'BHA15'}
          ,{value:'BHE22'}
          ,{value:'BHE23'}
          ,{value:'BHE40'}
          ,{value:'BHE41'}
          ,{value:'BMAL1'}
          ,{value:'BSH'}
          ,{value:'CDX1'}
          ,{value:'CDX2'}
          ,{value:'CDX4'}
          ,{value:'CEBPA'}
          ,{value:'CEBPB'}
          ,{value:'CEBPD'}
          ,{value:'CEBPE'}
          ,{value:'CEBPG'}
          ,{value:'CENPB'}
          ,{value:'CLOCK'}
          ,{value:'COE1'}
          ,{value:'COE2'}
          ,{value:'COE3'}
          ,{value:'COT1'}
          ,{value:'COT2'}
          ,{value:'CPEB1'}
          ,{value:'CR3L1'}
          ,{value:'CR3L2'}
          ,{value:'CR3L4'}
          ,{value:'CREB1'}
          ,{value:'CREB3'}
          ,{value:'CREB5'}
          ,{value:'CREM'}
          ,{value:'CRX'}
          ,{value:'CTCF'}
          ,{value:'CTCFL'}
          ,{value:'CUX1'}
          ,{value:'CUX2'}
          ,{value:'DBP'}
          ,{value:'DDIT3'}
          ,{value:'DLX1'}
          ,{value:'DLX2'}
          ,{value:'DLX3'}
          ,{value:'DLX4'}
          ,{value:'DLX5'}
          ,{value:'DLX6'}
          ,{value:'DMBX1'}
          ,{value:'DMRT1'}
          ,{value:'DMRT3'}
          ,{value:'DMRTA'}
          ,{value:'DMRTB'}
          ,{value:'DMRTD'}
          ,{value:'DMTA2'}
          ,{value:'DPF1'}
          ,{value:'DPRX'}
          ,{value:'DRGX'}
          ,{value:'DUX4'}
          ,{value:'DUXA'}
          ,{value:'E2F1'}
          ,{value:'E2F2'}
          ,{value:'E2F3'}
          ,{value:'E2F4'}
          ,{value:'E2F6'}
          ,{value:'E2F7'}
          ,{value:'E2F8'}
          ,{value:'E4F1'}
          ,{value:'EGR1'}
          ,{value:'EGR2'}
          ,{value:'EGR3'}
          ,{value:'EGR4'}
          ,{value:'EHF'}
          ,{value:'ELF1'}
          ,{value:'ELF2'}
          ,{value:'ELF3'}
          ,{value:'ELF4'}
          ,{value:'ELF5'}
          ,{value:'ELK1'}
          ,{value:'ELK3'}
          ,{value:'ELK4'}
          ,{value:'EMX1'}
          ,{value:'EMX2'}
          ,{value:'EOMES'}
          ,{value:'EPAS1'}
          ,{value:'ERF'}
          ,{value:'ERG'}
          ,{value:'ERR1'}
          ,{value:'ERR2'}
          ,{value:'ERR3'}
          ,{value:'ESR1'}
          ,{value:'ESR2'}
          ,{value:'ESX1'}
          ,{value:'ETS1'}
          ,{value:'ETS2'}
          ,{value:'ETV1'}
          ,{value:'ETV2'}
          ,{value:'ETV3'}
          ,{value:'ETV4'}
          ,{value:'ETV5'}
          ,{value:'ETV6'}
          ,{value:'ETV7'}
          ,{value:'EVX1'}
          ,{value:'EVX2'}
          ,{value:'FER3L'}
          ,{value:'FEV'}
          ,{value:'FEZF1'}
          ,{value:'FIGLA'}
          ,{value:'FLI1'}
          ,{value:'FOS'}
          ,{value:'FOSB'}
          ,{value:'FOSL1'}
          ,{value:'FOSL2'}
          ,{value:'FOXA1'}
          ,{value:'FOXA2'}
          ,{value:'FOXA3'}
          ,{value:'FOXB1'}
          ,{value:'FOXC1'}
          ,{value:'FOXC2'}
          ,{value:'FOXD2'}
          ,{value:'FOXD3'}
          ,{value:'FOXE1'}
          ,{value:'FOXF1'}
          ,{value:'FOXG1'}
          ,{value:'FOXH1'}
          ,{value:'FOXI1'}
          ,{value:'FOXJ2'}
          ,{value:'FOXJ3'}
          ,{value:'FOXK1'}
          ,{value:'FOXK2'}
          ,{value:'FOXL1'}
          ,{value:'FOXL2'}
          ,{value:'FOXM1'}
          ,{value:'FOXO1'}
          ,{value:'FOXO3'}
          ,{value:'FOXO4'}
          ,{value:'FOXO6'}
          ,{value:'FOXP1'}
          ,{value:'FOXP2'}
          ,{value:'FOXP3'}
          ,{value:'FOXR2'}
          ,{value:'GABPA'}
          ,{value:'GATA1'}
          ,{value:'GATA2'}
          ,{value:'GATA3'}
          ,{value:'GATA4'}
          ,{value:'GATA5'}
          ,{value:'GATA6'}
          ,{value:'GBX1'}
          ,{value:'GBX2'}
          ,{value:'GCM1'}
          ,{value:'GCM2'}
          ,{value:'GCR'}
          ,{value:'GFI1'}
          ,{value:'GFI1B'}
          ,{value:'GLI1'}
          ,{value:'GLI2'}
          ,{value:'GLI3'}
          ,{value:'GLI4'}
          ,{value:'GLIS1'}
          ,{value:'GLIS2'}
          ,{value:'GLIS3'}
          ,{value:'GMEB1'}
          ,{value:'GMEB2'}
          ,{value:'GRHL1'}
          ,{value:'GRHL2'}
          ,{value:'GSC'}
          ,{value:'GSC2'}
          ,{value:'GSX1'}
          ,{value:'GSX2'}
          ,{value:'HAND1'}
          ,{value:'HAND2'}
          ,{value:'HEN1'}
          ,{value:'HEN2'}
          ,{value:'HES1'}
          ,{value:'HES2'}
          ,{value:'HES5'}
          ,{value:'HES7'}
          ,{value:'HESX1'}
          ,{value:'HEY1'}
          ,{value:'HEY2'}
          ,{value:'HIC1'}
          ,{value:'HIC2'}
          ,{value:'HIF1A'}
          ,{value:'HIF3A'}
          ,{value:'HINFP'}
          ,{value:'HLF'}
          ,{value:'HMBX1'}
          ,{value:'HME1'}
          ,{value:'HME2'}
          ,{value:'HMGA1'}
          ,{value:'HMX1'}
          ,{value:'HMX2'}
          ,{value:'HMX3'}
          ,{value:'HNF1A'}
          ,{value:'HNF1B'}
          ,{value:'HNF4A'}
          ,{value:'HNF4G'}
          ,{value:'HNF6'}
          ,{value:'HOMEZ'}
          ,{value:'HSF1'}
          ,{value:'HSF2'}
          ,{value:'HSF4'}
          ,{value:'HSF5'}
          ,{value:'HSFY1'}
          ,{value:'HTF4'}
          ,{value:'HXA1'}
          ,{value:'HXA10'}
          ,{value:'HXA11'}
          ,{value:'HXA13'}
          ,{value:'HXA2'}
          ,{value:'HXA4'}
          ,{value:'HXA5'}
          ,{value:'HXA6'}
          ,{value:'HXA7'}
          ,{value:'HXA9'}
          ,{value:'HXB1'}
          ,{value:'HXB13'}
          ,{value:'HXB2'}
          ,{value:'HXB3'}
          ,{value:'HXB4'}
          ,{value:'HXB5'}
          ,{value:'HXB6'}
          ,{value:'HXB7'}
          ,{value:'HXB8'}
          ,{value:'HXB9'}
          ,{value:'HXC10'}
          ,{value:'HXC11'}
          ,{value:'HXC12'}
          ,{value:'HXC13'}
          ,{value:'HXC4'}
          ,{value:'HXC8'}
          ,{value:'HXC9'}
          ,{value:'HXD1'}
          ,{value:'HXD10'}
          ,{value:'HXD11'}
          ,{value:'HXD12'}
          ,{value:'HXD13'}
          ,{value:'HXD3'}
          ,{value:'HXD4'}
          ,{value:'HXD8'}
          ,{value:'HXD9'}
          ,{value:'IRF1'}
          ,{value:'IRF2'}
          ,{value:'IRF3'}
          ,{value:'IRF4'}
          ,{value:'IRF5'}
          ,{value:'IRF6'}
          ,{value:'IRF7'}
          ,{value:'IRF8'}
          ,{value:'IRF9'}
          ,{value:'IRX1'}
          ,{value:'IRX2'}
          ,{value:'IRX3'}
          ,{value:'IRX5'}
          ,{value:'ISL1'}
          ,{value:'ISL2'}
          ,{value:'ISX'}
          ,{value:'ITF2'}
          ,{value:'JDP2'}
          ,{value:'JUN'}
          ,{value:'JUNB'}
          ,{value:'JUND'}
          ,{value:'KAISO'}
          ,{value:'KLF1'}
          ,{value:'KLF10'}
          ,{value:'KLF11'}
          ,{value:'KLF12'}
          ,{value:'KLF13'}
          ,{value:'KLF14'}
          ,{value:'KLF15'}
          ,{value:'KLF16'}
          ,{value:'KLF17'}
          ,{value:'KLF2'}
          ,{value:'KLF3'}
          ,{value:'KLF4'}
          ,{value:'KLF5'}
          ,{value:'KLF6'}
          ,{value:'KLF7'}
          ,{value:'KLF8'}
          ,{value:'KLF9'}
          ,{value:'KMT2A'}
          ,{value:'KMT2B'}
          ,{value:'LBX2'}
          ,{value:'LEF1'}
          ,{value:'LHX1'}
          ,{value:'LHX2'}
          ,{value:'LHX3'}
          ,{value:'LHX4'}
          ,{value:'LHX5'}
          ,{value:'LHX6'}
          ,{value:'LHX8'}
          ,{value:'LHX9'}
          ,{value:'LMX1A'}
          ,{value:'LMX1B'}
          ,{value:'LRRF1'}
          ,{value:'LYL1'}
          ,{value:'RUNX1'}
          ,{value:'TFAP2A'}
          ,{value:'AR'}
          ,{value:'TBXT'}
          ,{value:'PAX5'}
          ,{value:'NR2F1'}
          ,{value:'NFIL3'}
          ,{value:'EN1'}
          ,{value:'FOXF2'}
          ,{value:'FOXD1'}
          ,{value:'NHLH1'}
          ,{value:'MEF2A'}
          ,{value:'MZF1'}
          ,{value:'MAX'}
          ,{value:'MAX::MYC'}
          ,{value:'NFYA'}
          ,{value:'NKX2-5'}
          ,{value:'PPARG::RXRA'}
          ,{value:'PPARG'}
          ,{value:'PAX2'}
          ,{value:'PAX4'}
          ,{value:'PAX6'}
          ,{value:'PBX1'}
          ,{value:'RORA'}
          ,{value:'RREB1'}
          ,{value:'RXRA::VDR'}
          ,{value:'PRRX2'}
          ,{value:'SOX9'}
          ,{value:'SP1'}
          ,{value:'SPI1'}
          ,{value:'SPIB'}
          ,{value:'SRF'}
          ,{value:'SRY'}
          ,{value:'ZNF143'}
          ,{value:'MAFG::NFE2L1'}
          ,{value:'TEAD1'}
          ,{value:'TAL1::TCF3'}
          ,{value:'USF1'}
          ,{value:'YY1'}
          ,{value:'FOS::JUN'}
          ,{value:'MYB'}
          ,{value:'REL'}
          ,{value:'ZEB1'}
          ,{value:'MYCN'}
          ,{value:'NFKB1'}
          ,{value:'TP53'}
          ,{value:'RELA'}
          ,{value:'NR3C1'}
          ,{value:'NR1H2::RXRA'}
          ,{value:'NFIC::TLX1'}
          ,{value:'NKX3-2'}
          ,{value:'NKX3-1'}
          ,{value:'ZNF354C'}
          ,{value:'PDX1'}
          ,{value:'STAT1'}
          ,{value:'REST'}
          ,{value:'GATA1::TAL1'}
          ,{value:'ESRRB'}
          ,{value:'SOX2'}
          ,{value:'STAT3'}
          ,{value:'MYC'}
          ,{value:'EWSR1-FLI1'}
          ,{value:'NFE2L2'}
          ,{value:'NFATC2'}
          ,{value:'EBF1'}
          ,{value:'INSM1'}
          ,{value:'HOXA5'}
          ,{value:'RARA::RXRA'}
          ,{value:'NR4A2'}
          ,{value:'NFIC'}
          ,{value:'PLAG1'}
          ,{value:'ARNT::HIF1A'}
          ,{value:'SOX10'}
          ,{value:'BATF::JUN'}
          ,{value:'BHLHE40'}
          ,{value:'HOXC9'}
          ,{value:'MAFF'}
          ,{value:'MAFK'}
          ,{value:'MEF2C'}
          ,{value:'MEIS1'}
          ,{value:'MYOD1'}
          ,{value:'MYOG'}
          ,{value:'MAF::NFE2'}
          ,{value:'NFYB'}
          ,{value:'NR2C2'}
          ,{value:'NRF1'}
          ,{value:'POU2F2'}
          ,{value:'PRDM1'}
          ,{value:'RFX1'}
          ,{value:'RFX5'}
          ,{value:'RUNX2'}
          ,{value:'SP2'}
          ,{value:'STAT1::STAT2'}
          ,{value:'TCF3'}
          ,{value:'TCF7L2'}
          ,{value:'TFAP2C'}
          ,{value:'TP63'}
          ,{value:'USF2'}
          ,{value:'ZBTB33'}
          ,{value:'ZNF263'}
          ,{value:'ESRRA'}
          ,{value:'HOXA9'}
          ,{value:'SREBF1'}
          ,{value:'SREBF2'}
          ,{value:'THAP1'}
          ,{value:'RFX2'}
          ,{value:'BHLHA15'}
          ,{value:'LBX1'}
          ,{value:'MITF'}
          ,{value:'NEUROG1'}
          ,{value:'NFATC3'}
          ,{value:'POU2F3'}
          ,{value:'POU6F1'}
          ,{value:'SHOX'}
          ,{value:'TCFL5'}
          ,{value:'BARHL2'}
          ,{value:'BHLHE41'}
          ,{value:'EN2'}
          ,{value:'HOXA13'}
          ,{value:'HOXC11'}
          ,{value:'MAFG'}
          ,{value:'MEF2B'}
          ,{value:'MEOX1'}
          ,{value:'MIXL1'}
          ,{value:'MLX'}
          ,{value:'MLXIPL'}
          ,{value:'MSC'}
          ,{value:'MSX1'}
          ,{value:'MYF6'}
          ,{value:'NEUROD2'}
          ,{value:'NEUROG2'}
          ,{value:'NFIA'}
          ,{value:'NFIX'}
          ,{value:'NKX2-3'}
          ,{value:'NKX2-8'}
          ,{value:'NKX6-1'}
          ,{value:'NKX6-2'}
          ,{value:'OLIG2'}
          ,{value:'ONECUT1'}
          ,{value:'PAX7'}
          ,{value:'PHOX2B'}
          ,{value:'PITX1'}
          ,{value:'POU4F2'}
          ,{value:'RUNX3'}
          ,{value:'SP4'}
          ,{value:'SPDEF'}
          ,{value:'SPIC'}
          ,{value:'TBX2'}
          ,{value:'TBX20'}
          ,{value:'TBX21'}
          ,{value:'TFAP4'}
          ,{value:'TFEB'}
          ,{value:'VDR'}
          ,{value:'ZBTB7B'}
          ,{value:'ZBTB7C'}
          ,{value:'ZIC1'}
          ,{value:'ZIC3'}
          ,{value:'ZBTB18'}
          ,{value:'MEOX2'}
          ,{value:'MNX1'}
          ,{value:'MSX2'}
          ,{value:'NOTO'}
          ,{value:'OTX1'}
          ,{value:'OTX2'}
          ,{value:'PHOX2A'}
          ,{value:'PITX3'}
          ,{value:'PROP1'}
          ,{value:'PRRX1'}
          ,{value:'RAX2'}
          ,{value:'RAX'}
          ,{value:'RHOXF1'}
          ,{value:'UNCX'}
          ,{value:'VAX1'}
          ,{value:'VAX2'}
          ,{value:'VENTX'}
          ,{value:'VSX1'}
          ,{value:'VSX2'}
          ,{value:'NR3C2'}
          ,{value:'RARA'}
          ,{value:'SCRT1'}
          ,{value:'SCRT2'}
          ,{value:'SNAI2'}
          ,{value:'SP3'}
          ,{value:'SP8'}
          ,{value:'YY2'}
          ,{value:'ZBED1'}
          ,{value:'ZBTB7A'}
          ,{value:'ZIC4'}
          ,{value:'ZNF410'}
          ,{value:'ZNF740'}
          ,{value:'ONECUT2'}
          ,{value:'ONECUT3'}
          ,{value:'TCF7'}
          ,{value:'MEF2D'}
          ,{value:'MEIS2'}
          ,{value:'MEIS3'}
          ,{value:'MYBL1'}
          ,{value:'MYBL2'}
          ,{value:'NFKB2'}
          ,{value:'PAX1'}
          ,{value:'PAX3'}
          ,{value:'PAX9'}
          ,{value:'PKNOX1'}
          ,{value:'PKNOX2'}
          ,{value:'POU1F1'}
          ,{value:'POU2F1'}
          ,{value:'POU3F1'}
          ,{value:'POU3F2'}
          ,{value:'POU3F3'}
          ,{value:'POU3F4'}
          ,{value:'POU4F1'}
          ,{value:'POU4F3'}
          ,{value:'POU5F1B'}
          ,{value:'POU6F2'}
          ,{value:'PROX1'}
          ,{value:'SMAD3'}
          ,{value:'TGIF1'}
          ,{value:'TGIF2'}
          ,{value:'RFX3'}
          ,{value:'RFX4'}
          ,{value:'MGA'}
          ,{value:'TBR1'}
          ,{value:'TBX15'}
          ,{value:'TBX19'}
          ,{value:'TBX1'}
          ,{value:'TBX4'}
          ,{value:'TBX5'}
          ,{value:'TEAD3'}
          ,{value:'TEAD4'}
          ,{value:'TFAP2B'}
          ,{value:'BHLHE23'}
          ,{value:'BHLHE22'}
          ,{value:'MNT'}
          ,{value:'OLIG1'}
          ,{value:'OLIG3'}
          ,{value:'TCF4'}
          ,{value:'TFE3'}
          ,{value:'CREB3L1'}
          ,{value:'NFE2'}
          ,{value:'NRL'}
          ,{value:'TEF'}
          ,{value:'XBP1'}
          ,{value:'RXRB'}
          ,{value:'RXRG'}
          ,{value:'TP73'}
          ,{value:'MTF1'}
          ,{value:'SOX21'}
          ,{value:'SOX4'}
          ,{value:'SOX8'}
          ,{value:'TFEC'}
          ,{value:'HOXD12'}
          ,{value:'BSX'}
          ,{value:'BARHL1'}
          ,{value:'HMBOX1'}
          ,{value:'HOXA10'}
          ,{value:'HOXA2'}
          ,{value:'HOXB13'}
          ,{value:'HOXB2'}
          ,{value:'HOXB3'}
          ,{value:'HOXB5'}
          ,{value:'HOXC10'}
          ,{value:'HOXC12'}
          ,{value:'HOXC13'}
          ,{value:'HOXD11'}
          ,{value:'HOXD13'}
          ,{value:'HOXD8'}
          ,{value:'HOXD3'}
          ,{value:'HOXD9'}
          ,{value:'MXI1'}
          ,{value:'NEUROD1'}
          ,{value:'NR1H4'}
          ,{value:'NR2F2'}
          ,{value:'NR4A1'}
          ,{value:'PBX2'}
          ,{value:'PBX3'}
          ,{value:'POU5F1'}
          ,{value:'RBPJ'}
          ,{value:'RELB'}
          ,{value:'SIX1'}
          ,{value:'SIX2'}
          ,{value:'SOX13'}
          ,{value:'TEAD2'}
          ,{value:'TFDP1'}
          ,{value:'TWIST1'}
          ,{value:'ZNF24'}
          ,{value:'ZNF384'}
          ,{value:'FOSB::JUN'}
          ,{value:'FOSL1::JUN'}
          ,{value:'FOSL2::JUN'}
          ,{value:'JUN::JUNB'}
          ,{value:'FOS::JUNB'}
          ,{value:'FOSB::JUNB'}
          ,{value:'FOSL1::JUNB'}
          ,{value:'FOSL2::JUNB'}
          ,{value:'FOS::JUND'}
          ,{value:'FOSL1::JUND'}
          ,{value:'FOSL2::JUND'}
          ,{value:'NR1H4::RXRA'}
          ,{value:'NR4A2::RXRA'}
          ,{value:'PPARA::RXRA'}
          ,{value:'RARA::RXRG'}
          ,{value:'RORB'}
          ,{value:'RORC'}
          ,{value:'SOX15'}
          ,{value:'ZNF282'}
          ,{value:'ZSCAN4'}
          ,{value:'TCF7L1'}
          ,{value:'ATF6'}
          ,{value:'ATOH7'}
          ,{value:'CREB3L4'}
          ,{value:'DMRTA2'}
          ,{value:'DMRTC2'}
          ,{value:'FERD3L'}
          ,{value:'FOXN3'}
          ,{value:'HES6'}
          ,{value:'HOXA1'}
          ,{value:'HOXA4'}
          ,{value:'HOXA6'}
          ,{value:'HOXA7'}
          ,{value:'HOXB4'}
          ,{value:'HOXB6'}
          ,{value:'HOXB7'}
          ,{value:'HOXB8'}
          ,{value:'HOXB9'}
          ,{value:'HOXC4'}
          ,{value:'HOXC8'}
          ,{value:'HOXD10'}
          ,{value:'HOXD4'}
          ,{value:'IKZF1'}
          ,{value:'MAF'}
          ,{value:'MAFA'}
          ,{value:'MAZ'}
          ,{value:'MSANTD3'}
          ,{value:'MSGN1'}
          ,{value:'NFATC4'}
          ,{value:'NHLH2'}
          ,{value:'NKX6-3'}
          ,{value:'NR1D1'}
          ,{value:'NR1D2'}
          ,{value:'NR1I2'}
          ,{value:'NR1I3'}
          ,{value:'NR2C1'}
          ,{value:'NR2F6'}
          ,{value:'NR5A1'}
          ,{value:'NR6A1'}
          ,{value:'OSR1'}
          ,{value:'OVOL1'}
          ,{value:'OVOL2'}
          ,{value:'PITX2'}
          ,{value:'PLAGL2'}
          ,{value:'PPARD'}
          ,{value:'RARB'}
          ,{value:'RARG'}
          ,{value:'RFX7'}
          ,{value:'SMAD5'}
          ,{value:'SNAI1'}
          ,{value:'SNAI3'}
          ,{value:'SOHLH2'}
          ,{value:'SOX12'}
          ,{value:'SOX14'}
          ,{value:'SOX18'}
          ,{value:'SP9'}
          ,{value:'TBX18'}
          ,{value:'TBX3'}
          ,{value:'TBX6'}
          ,{value:'TCF21'}
          ,{value:'TFAP2E'}
          ,{value:'TGIF2LX'}
          ,{value:'TGIF2LY'}
          ,{value:'THAP11'}
          ,{value:'THRB'}
          ,{value:'TLX2'}
          ,{value:'VEZF1'}
          ,{value:'ZBTB26'}
          ,{value:'ZBTB32'}
          ,{value:'ZBTB6'}
          ,{value:'ZFP57'}
          ,{value:'ZIC5'}
          ,{value:'ZKSCAN1'}
          ,{value:'ZNF135'}
          ,{value:'ZNF136'}
          ,{value:'ZNF140'}
          ,{value:'ZNF274'}
          ,{value:'ZNF317'}
          ,{value:'ZNF382'}
          ,{value:'ZNF460'}
          ,{value:'ZNF528'}
          ,{value:'ZNF682'}
          ,{value:'ZNF684'}
          ,{value:'ZNF75D'}
          ,{value:'ZSCAN29'}
          ,{value:'ZNF281'}
          ,{value:'EBF3'}
          ,{value:'MYF5'}
          ,{value:'NFIB'}
          ,{value:'NFYC'}
          ,{value:'NKX2-2'}
          ,{value:'OSR2'}
          ,{value:'PRDM4'}
          ,{value:'TCF12'}
          ,{value:'ZBTB12'}
          ,{value:'ZBTB14'}
          ,{value:'ZFP42'}
          ,{value:'ZKSCAN5'}
          ,{value:'ZNF148'}
          ,{value:'ZNF16'}
          ,{value:'ZNF341'}
          ,{value:'ZNF449'}
          ,{value:'ZNF652'}
          ,{value:'DMRTA1'}
          ,{value:'ZIM3'}
          ,{value:'ZNF257'}
          ,{value:'ZNF343'}
          ,{value:'ZNF454'}
          ,{value:'ZNF610'}
          ,{value:'ZNF675'}
          ,{value:'ZNF707'}
          ,{value:'ZNF76'}
          ,{value:'ZNF784'}
          ,{value:'ZNF8'}
          ,{value:'ZNF816'}
          ,{value:'ZNF85'}
          ,{value:'ZNF93'}
          ,{value:'ZSCAN31'}
          ,{value:'PRDM9'}
          ,{value:'ZNF189'}
          ,{value:'ZNF331'}
          ,{value:'ZNF417'}
          ,{value:'ZNF549'}
          ,{value:'ZNF680'}
          ,{value:'ZNF708'}
          ,{value:'ZNF768'}
          ,{value:'BNC2'}
          ,{value:'ELK1::HOXA1'}
          ,{value:'ELK1::HOXB13'}
          ,{value:'ELK1::SREBF2'}
          ,{value:'ERF::FIGLA'}
          ,{value:'ERF::FOXI1'}
          ,{value:'ERF::FOXO1'}
          ,{value:'ERF::HOXB13'}
          ,{value:'ERF::NHLH1'}
          ,{value:'ERF::SREBF2'}
          ,{value:'ETV2::DRGX'}
          ,{value:'ETV2::FIGLA'}
          ,{value:'ETV2::FOXI1'}
          ,{value:'ETV2::HOXB13'}
          ,{value:'ETV5::DRGX'}
          ,{value:'ETV5::FIGLA'}
          ,{value:'ETV5::FOXI1'}
          ,{value:'ETV5::FOXO1'}
          ,{value:'ETV5::HOXA2'}
          ,{value:'FLI1::DRGX'}
          ,{value:'FLI1::FOXI1'}
          ,{value:'FOXJ2::ELF1'}
          ,{value:'FOXO1::ELF1'}
          ,{value:'FOXO1::ELK1'}
          ,{value:'FOXO1::ELK3'}
          ,{value:'FOXO1::FLI1'}
          ,{value:'HOXB2::ELK1'}
          ,{value:'HOXD12::ELK1'}
          ,{value:'MGA::EVX1'}
          ,{value:'PATZ1'}
          ,{value:'POU2F1::SOX2'}
          ,{value:'SATB1'}
          ,{value:'SMAD2'}
          ,{value:'SP5'}
          ,{value:'TFAP4::ETV1'}
          ,{value:'TFAP4::FLI1'}
          ,{value:'TFCP2'}
          ,{value:'THRA'}
          ,{value:'TRPS1'}
          ,{value:'ZBED2'}
          ,{value:'ZFP14'}
          ,{value:'ZKSCAN3'}
          ,{value:'ZNF211'}
          ,{value:'ZNF214'}
          ,{value:'ZNF320'}
          ,{value:'ZNF324'}
          ,{value:'ZNF354A'}
          ,{value:'ZNF416'}
          ,{value:'ZNF418'}
          ,{value:'ZNF530'}
          ,{value:'ZNF574'}
          ,{value:'ZNF582'}
          ,{value:'ZNF667'}
          ,{value:'ZNF669'}
          ,{value:'ZNF692'}
          ,{value:'ZNF701'}
          ,{value:'NKX2-4'}
          ,{value:'HOXB1'}
          ,{value:'PAX8'}
          ,{value:'ZNF524'}
          ,{value:'ZNF75A'}
          ,{value:'ZNF766'}
          ,{value:'ZNF770'}
          ,{value:'ZSCAN16'}
          ,{value:'ZNF677'}
          ,{value:'ZBTB17'}
          ,{value:'FOXP4'}
          ,{value:'FOXS1'}
          ,{value:'HOXA3'}
          ,{value:'ZNF184'}
          ,{value:'ZNF213'}
          ,{value:'BCL11A'}
          ,{value:'IKZF2'}
          ,{value:'PGR'}
          ,{value:'ZBED4'}
          ,{value:'ZBTB11'}
          ,{value:'ZBTB24'}
          ,{value:'ZNF157'}
          ,{value:'ZNF175'}
          ,{value:'ZNF35'}
          ,{value:'ZNF547'}
          ,{value:'ZNF558'}
          ,{value:'ZSCAN21'}
          ,{value:'FEZF2'}
          ,{value:'MAD4'}
          ,{value:'MAFB'}
          ,{value:'MBNL2'}
          ,{value:'MCR'}
          ,{value:'MESP1'}
          ,{value:'MESP2'}
          ,{value:'MGAP'}
          ,{value:'MLXPL'}
          ,{value:'MUSC'}
          ,{value:'MYBA'}
          ,{value:'MYBB'}
          ,{value:'MYNN'}
          ,{value:'MYT1L'}
          ,{value:'NANOG'}
          ,{value:'NDF1'}
          ,{value:'NDF2'}
          ,{value:'NF2L1'}
          ,{value:'NF2L2'}
          ,{value:'NFAC1'}
          ,{value:'NFAC2'}
          ,{value:'NFAC3'}
          ,{value:'NFAC4'}
          ,{value:'NFAT5'}
          ,{value:'NGN1'}
          ,{value:'NGN2'}
          ,{value:'NKX21'}
          ,{value:'NKX22'}
          ,{value:'NKX23'}
          ,{value:'NKX25'}
          ,{value:'NKX28'}
          ,{value:'NKX31'}
          ,{value:'NKX32'}
          ,{value:'NKX61'}
          ,{value:'NKX62'}
          ,{value:'NKX63'}
          ,{value:'NPAS2'}
          ,{value:'NPAS3'}
          ,{value:'NPAS4'}
          ,{value:'NR1H2'}
          ,{value:'NR1H3'}
          ,{value:'NR2E1'}
          ,{value:'NR5A2'}
          ,{value:'ONEC2'}
          ,{value:'ONEC3'}
          ,{value:'OZF'}
          ,{value:'P53'}
          ,{value:'P5F1B'}
          ,{value:'P63'}
          ,{value:'P73'}
          ,{value:'PHX2A'}
          ,{value:'PHX2B'}
          ,{value:'PIT1'}
          ,{value:'PKNX1'}
          ,{value:'PKNX2'}
          ,{value:'PO2F1'}
          ,{value:'PO2F2'}
          ,{value:'PO2F3'}
          ,{value:'PO3F1'}
          ,{value:'PO3F2'}
          ,{value:'PO3F3'}
          ,{value:'PO3F4'}
          ,{value:'PO4F1'}
          ,{value:'PO4F2'}
          ,{value:'PO4F3'}
          ,{value:'PO5F1'}
          ,{value:'PO6F1'}
          ,{value:'PO6F2'}
          ,{value:'PPARA'}
          ,{value:'PRD13'}
          ,{value:'PRD14'}
          ,{value:'PRD15'}
          ,{value:'PRD16'}
          ,{value:'PRDM5'}
          ,{value:'PRDM6'}
          ,{value:'PRGR'}
          ,{value:'PTF1A'}
          ,{value:'RBAK'}
          ,{value:'RFX6'}
          ,{value:'RHXF1'}
          ,{value:'RHXF2'}
          ,{value:'RORG'}
          ,{value:'RX'}
          ,{value:'RXRA'}
          ,{value:'SALL1'}
          ,{value:'SALL4'}
          ,{value:'SHOX2'}
          ,{value:'SIX3'}
          ,{value:'SIX4'}
          ,{value:'SIX6'}
          ,{value:'SKOR1'}
          ,{value:'SKOR2'}
          ,{value:'SMAD4'}
          ,{value:'SOLH2'}
          ,{value:'SOX1'}
          ,{value:'SOX11'}
          ,{value:'SOX17'}
          ,{value:'SOX3'}
          ,{value:'SOX30'}
          ,{value:'SOX5'}
          ,{value:'SOX6'}
          ,{value:'SOX7'}
          ,{value:'SP7'}
          ,{value:'SRBP1'}
          ,{value:'SRBP2'}
          ,{value:'STA5A'}
          ,{value:'STA5B'}
          ,{value:'STAT2'}
          ,{value:'STAT4'}
          ,{value:'STAT6'}
          ,{value:'STF1'}
          ,{value:'SUH'}
          ,{value:'TAF1'}
          ,{value:'TAL1'}
          ,{value:'TBP'}
          ,{value:'TF2L1'}
          ,{value:'TF2LX'}
          ,{value:'TF2LY'}
          ,{value:'TF65'}
          ,{value:'TF7L1'}
          ,{value:'TF7L2'}
          ,{value:'TFE2'}
          ,{value:'THA'}
          ,{value:'THB'}
          ,{value:'TLX3'}
          ,{value:'TWST1'}
          ,{value:'TWST2'}
          ,{value:'TYY1'}
          ,{value:'TYY2'}
          ,{value:'TZAP'}
          ,{value:'UBIP1'}
          ,{value:'BBX'}
          ,{value:'BCL11B'}
          ,{value:'RHOXF2'}
          ,{value:'YBX1'}
          ,{value:'ZBTB20'}
          ,{value:'ZBTB22'}
          ,{value:'ZBTB37'}
          ,{value:'ZBTB40'}
          ,{value:'ZBTB43'}
          ,{value:'ZBTB44'}
          ,{value:'ZBTB45'}
          ,{value:'ZFP1'}
          ,{value:'ZFP28'}
          ,{value:'ZFP3'}
          ,{value:'ZFP41'}
          ,{value:'ZFP64'}
          ,{value:'ZFP69'}
          ,{value:'ZNF10'}
          ,{value:'ZNF100'}
          ,{value:'ZNF101'}
          ,{value:'ZNF12'}
          ,{value:'ZNF134'}
          ,{value:'ZNF141'}
          ,{value:'ZNF174'}
          ,{value:'ZNF177'}
          ,{value:'ZNF23'}
          ,{value:'ZNF248'}
          ,{value:'ZNF254'}
          ,{value:'ZNF260'}
          ,{value:'ZNF276'}
          ,{value:'ZNF28'}
          ,{value:'ZNF284'}
          ,{value:'ZNF296'}
          ,{value:'ZNF304'}
          ,{value:'ZNF32'}
          ,{value:'ZNF322'}
          ,{value:'ZNF345'}
          ,{value:'ZNF385D'}
          ,{value:'ZNF396'}
          ,{value:'ZNF429'}
          ,{value:'ZNF430'}
          ,{value:'ZNF441'}
          ,{value:'ZNF444'}
          ,{value:'ZNF479'}
          ,{value:'ZNF490'}
          ,{value:'ZNF506'}
          ,{value:'ZNF525'}
          ,{value:'ZNF565'}
          ,{value:'ZNF580'}
          ,{value:'ZNF585B'}
          ,{value:'ZNF597'}
          ,{value:'ZNF623'}
          ,{value:'ZNF660'}
          ,{value:'ZNF704'}
          ,{value:'ZNF713'}
          ,{value:'ZNF750'}
          ,{value:'ZNF765'}
          ,{value:'ZNF771'}
          ,{value:'ZNF780A'}
          ,{value:'ZNF781'}
          ,{value:'ZNF787'}
          ,{value:'ZNF793'}
          ,{value:'ZNF808'}
          ,{value:'ZNF81'}
          ,{value:'ZNF821'}
          ,{value:'ZNF823'}
          ,{value:'ZNF84'}
          ,{value:'ZNF92'}
          ,{value:'ZSCAN1'}
          ,{value:'ZSCAN20'}
          ,{value:'ZSCAN23'}
          ,{value:'ZSCAN5A'}
          ,{value:'ZSCAN9'}
          ,{value:'ADNP'}
          ,{value:'ZBTB42'}
          ,{value:'ZNF133'}
          ,{value:'ZNF146'}
          ,{value:'ZNF18'}
          ,{value:'ZNF316'}
          ,{value:'ZNF329'}
          ,{value:'ZNF425'}
          ,{value:'ZNF436'}
          ,{value:'ZNF45'}
          ,{value:'ZNF467'}
          ,{value:'ZNF468'}
          ,{value:'ZNF513'}
          ,{value:'ZNF519'}
          ,{value:'ZNF534'}
          ,{value:'ZNF548'}
          ,{value:'ZNF596'}
          ,{value:'ZNF671'}
          ,{value:'ALX4::TBX21'}
          ,{value:'CUX1::HOXA13'}
          ,{value:'CUX1::HOXB13'}
          ,{value:'CUX1::TBX21'}
          ,{value:'E2F1::HES7'}
          ,{value:'E2F3::DRGX'}
          ,{value:'E2F3::ONECUT2'}
          ,{value:'ELK1::EOMES'}
          ,{value:'ELK1::ETV7'}
          ,{value:'ELK1::FOXI1'}
          ,{value:'ELK1::HOXA3'}
          ,{value:'ELK1::ONECUT2'}
          ,{value:'ELK1::PAX1'}
          ,{value:'ELK1::PAX5'}
          ,{value:'ELK1::PAX9'}
          ,{value:'ELK1::SPDEF'}
          ,{value:'ELK1::TEF'}
          ,{value:'ERF::CEBPD'}
          ,{value:'ERF::ETV7'}
          ,{value:'ERF::MAX'}
          ,{value:'ERF::TBX21'}
          ,{value:'ETV2::BHLHA15'}
          ,{value:'ETV2::CEBPD'}
          ,{value:'ETV2::EOMES'}
          ,{value:'ETV2::ETV7'}
          ,{value:'ETV2::FOXO6'}
          ,{value:'ETV2::NHLH1'}
          ,{value:'ETV2::ONECUT2'}
          ,{value:'ETV2::SPDEF'}
          ,{value:'ETV2::SREBF2'}
          ,{value:'ETV2::TEF'}
          ,{value:'ETV5::CEBPD'}
          ,{value:'ETV5::ETV7'}
          ,{value:'FLI1::BHLHA15'}
          ,{value:'FLI1::CEBPB'}
          ,{value:'FLI1::CEBPD'}
          ,{value:'FLI1::ETV7'}
          ,{value:'FLI1::FIGLA'}
          ,{value:'FLI1::HOXB13'}
          ,{value:'FLI1::MAX'}
          ,{value:'FOXJ2::HOXB13'}
          ,{value:'FOXJ2::PITX1'}
          ,{value:'GCM1::ELF1'}
          ,{value:'GCM1::ELK1'}
          ,{value:'GCM1::ELK3'}
          ,{value:'GCM1::ETV4'}
          ,{value:'GCM1::FOXI1'}
          ,{value:'GCM1::HOXB13'}
          ,{value:'GCM1::ONECUT2'}
          ,{value:'GCM1::SOX2'}
          ,{value:'GCM1::TBX21'}
          ,{value:'GCM2::DRGX'}
          ,{value:'GCM2::ELK1'}
          ,{value:'GCM2::HOXA13'}
          ,{value:'GCM2::PITX1'}
          ,{value:'GCM2::TBX21'}
          ,{value:'HKR1'}
          ,{value:'HOXB13::ELK1'}
          ,{value:'HOXB2::PAX1'}
          ,{value:'HOXB2::PAX5'}
          ,{value:'HOXB2::PAX9'}
          ,{value:'HOXB2::TBX21'}
          ,{value:'HOXB2::TBX3'}
          ,{value:'HOXC10::TBX21'}
          ,{value:'HOXD12::ELK3'}
          ,{value:'HOXD12::ETV1'}
          ,{value:'HOXD12::ETV4'}
          ,{value:'MEIS1::DRGX'}
          ,{value:'MEIS1::EVX1'}
          ,{value:'MGA::DLX2'}
          ,{value:'MGA::DLX3'}
          ,{value:'MYBL1::TBX21'}
          ,{value:'PITX1::HES7'}
          ,{value:'PITX1::TBX21'}
          ,{value:'POU2F1::DLX2'}
          ,{value:'POU2F1::ELK1'}
          ,{value:'POU2F1::ETV1'}
          ,{value:'TCF15'}
          ,{value:'TEAD4::DRGX'}
          ,{value:'TEAD4::ELF1'}
          ,{value:'TEAD4::ELK1'}
          ,{value:'TEAD4::ETV7'}
          ,{value:'TEAD4::SPDEF'}
          ,{value:'TEAD4::SPIB'}
          ,{value:'ZBTB21'}
          ,{value:'ZFP69B'}
          ,{value:'ZFP82'}
          ,{value:'ZIK1'}
          ,{value:'ZKSCAN8'}
          ,{value:'ZNF112'}
          ,{value:'ZNF132'}
          ,{value:'ZNF182'}
          ,{value:'ZNF19'}
          ,{value:'ZNF195'}
          ,{value:'ZNF222'}
          ,{value:'ZNF223'}
          ,{value:'ZNF250'}
          ,{value:'ZNF264'}
          ,{value:'ZNF266'}
          ,{value:'ZNF273'}
          ,{value:'ZNF333'}
          ,{value:'ZNF337'}
          ,{value:'ZNF33B'}
          ,{value:'ZNF350'}
          ,{value:'ZNF37A'}
          ,{value:'ZNF433'}
          ,{value:'ZNF440'}
          ,{value:'ZNF462'}
          ,{value:'ZNF480'}
          ,{value:'ZNF483'}
          ,{value:'ZNF484'}
          ,{value:'ZNF485'}
          ,{value:'ZNF491'}
          ,{value:'ZNF492'}
          ,{value:'ZNF502'}
          ,{value:'ZNF507'}
          ,{value:'ZNF527'}
          ,{value:'ZNF529'}
          ,{value:'ZNF540'}
          ,{value:'ZNF543'}
          ,{value:'ZNF544'}
          ,{value:'ZNF554'}
          ,{value:'ZNF560'}
          ,{value:'ZNF566'}
          ,{value:'ZNF567'}
          ,{value:'ZNF570'}
          ,{value:'ZNF571'}
          ,{value:'ZNF573'}
          ,{value:'ZNF585A'}
          ,{value:'ZNF586'}
          ,{value:'ZNF587'}
          ,{value:'ZNF594'}
          ,{value:'ZNF611'}
          ,{value:'ZNF614'}
          ,{value:'ZNF616'}
          ,{value:'ZNF627'}
          ,{value:'ZNF629'}
          ,{value:'ZNF662'}
          ,{value:'ZNF664'}
          ,{value:'ZNF674'}
          ,{value:'ZNF681'}
          ,{value:'ZNF7'}
          ,{value:'ZNF714'}
          ,{value:'ZNF716'}
          ,{value:'ZNF736'}
          ,{value:'ZNF749'}
          ,{value:'ZNF77'}
          ,{value:'ZNF774'}
          ,{value:'ZNF778'}
          ,{value:'ZNF783'}
          ,{value:'ZNF786'}
          ,{value:'ZNF789'}
          ,{value:'ZNF79'}
          ,{value:'ZNF799'}
          ,{value:'ZNF846'}
          ,{value:'ZNF860'}
          ,{value:'ZNF880'}
          ,{value:'ZNF891'}
          ,{value:'ZNF98'}
          ,{value:'ZSCAN22'}
          ,{value:'ATF5'}
          ,{value:'CEBPZ'}
          ,{value:'MXD4'}
          ,{value:'NONO'}
          ,{value:'OVOL3'}
          ,{value:'PBX4'}
          ,{value:'ZBTB48'}
          ,{value:'ZNF280D'}
          ,{value:'ZNF30'}
          ,{value:'ZNF366'}
          ,{value:'ZNF394'}
          ,{value:'ZNF41'}
          ,{value:'ZNF486'}
          ,{value:'ZNF577'}
          ,{value:'ZNF791'}
          ,{value:'THAP5'}
          ,{value:'ZNF48'}
          ,{value:'UNC4'}
          ,{value:'WT1'}
          ,{value:'YBOX1'}
          ,{value:'Z280A'}
          ,{value:'Z324A'}
          ,{value:'Z354A'}
          ,{value:'Z585A'}
          ,{value:'Z585B'}
          ,{value:'Z705G'}
          ,{value:'Z780A'}
          ,{value:'ZBED5'}
          ,{value:'ZBT12'}
          ,{value:'ZBT14'}
          ,{value:'ZBT16'}
          ,{value:'ZBT17'}
          ,{value:'ZBT18'}
          ,{value:'ZBT20'}
          ,{value:'ZBT22'}
          ,{value:'ZBT24'}
          ,{value:'ZBT26'}
          ,{value:'ZBT37'}
          ,{value:'ZBT40'}
          ,{value:'ZBT42'}
          ,{value:'ZBT43'}
          ,{value:'ZBT44'}
          ,{value:'ZBT45'}
          ,{value:'ZBT49'}
          ,{value:'ZBT7A'}
          ,{value:'ZBT7B'}
          ,{value:'ZBT7C'}
          ,{value:'ZBTB2'}
          ,{value:'ZEB2'}
          ,{value:'ZF64B'}
          ,{value:'ZF69B'}
          ,{value:'ZFP37'}
          ,{value:'ZFP90'}
          ,{value:'ZFP91'}
          ,{value:'ZFX'}
          ,{value:'ZIC2'}
          ,{value:'ZKSC1'}
          ,{value:'ZKSC5'}
          ,{value:'ZKSC8'}
          ,{value:'ZN100'}
          ,{value:'ZN101'}
          ,{value:'ZN112'}
          ,{value:'ZN121'}
          ,{value:'ZN124'}
          ,{value:'ZN132'}
          ,{value:'ZN133'}
          ,{value:'ZN134'}
          ,{value:'ZN135'}
          ,{value:'ZN136'}
          ,{value:'ZN140'}
          ,{value:'ZN141'}
          ,{value:'ZN143'}
          ,{value:'ZN148'}
          ,{value:'ZN154'}
          ,{value:'ZN157'}
          ,{value:'ZN160'}
          ,{value:'ZN165'}
          ,{value:'ZN174'}
          ,{value:'ZN177'}
          ,{value:'ZN180'}
          ,{value:'ZN184'}
          ,{value:'ZN189'}
          ,{value:'ZN197'}
          ,{value:'ZN205'}
          ,{value:'ZN211'}
          ,{value:'ZN213'}
          ,{value:'ZN214'}
          ,{value:'ZN222'}
          ,{value:'ZN223'}
          ,{value:'ZN224'}
          ,{value:'ZN239'}
          ,{value:'ZN248'}
          ,{value:'ZN250'}
          ,{value:'ZN251'}
          ,{value:'ZN254'}
          ,{value:'ZN257'}
          ,{value:'ZN260'}
          ,{value:'ZN263'}
          ,{value:'ZN264'}
          ,{value:'ZN266'}
          ,{value:'ZN267'}
          ,{value:'ZN273'}
          ,{value:'ZN274'}
          ,{value:'ZN276'}
          ,{value:'ZN281'}
          ,{value:'ZN282'}
          ,{value:'ZN283'}
          ,{value:'ZN284'}
          ,{value:'ZN285'}
          ,{value:'ZN296'}
          ,{value:'ZN302'}
          ,{value:'ZN304'}
          ,{value:'ZN316'}
          ,{value:'ZN317'}
          ,{value:'ZN320'}
          ,{value:'ZN322'}
          ,{value:'ZN329'}
          ,{value:'ZN331'}
          ,{value:'ZN333'}
          ,{value:'ZN335'}
          ,{value:'ZN337'}
          ,{value:'ZN33B'}
          ,{value:'ZN341'}
          ,{value:'ZN343'}
          ,{value:'ZN350'}
          ,{value:'ZN362'}
          ,{value:'ZN37A'}
          ,{value:'ZN382'}
          ,{value:'ZN383'}
          ,{value:'ZN384'}
          ,{value:'ZN394'}
          ,{value:'ZN407'}
          ,{value:'ZN410'}
          ,{value:'ZN416'}
          ,{value:'ZN417'}
          ,{value:'ZN418'}
          ,{value:'ZN423'}
          ,{value:'ZN425'}
          ,{value:'ZN429'}
          ,{value:'ZN430'}
          ,{value:'ZN431'}
          ,{value:'ZN432'}
          ,{value:'ZN433'}
          ,{value:'ZN436'}
          ,{value:'ZN440'}
          ,{value:'ZN441'}
          ,{value:'ZN443'}
          ,{value:'ZN444'}
          ,{value:'ZN449'}
          ,{value:'ZN454'}
          ,{value:'ZN460'}
          ,{value:'ZN467'}
          ,{value:'ZN468'}
          ,{value:'ZN479'}
          ,{value:'ZN480'}
          ,{value:'ZN483'}
          ,{value:'ZN484'}
          ,{value:'ZN485'}
          ,{value:'ZN490'}
          ,{value:'ZN492'}
          ,{value:'ZN502'}
          ,{value:'ZN506'}
          ,{value:'ZN510'}
          ,{value:'ZN519'}
          ,{value:'ZN524'}
          ,{value:'ZN527'}
          ,{value:'ZN528'}
          ,{value:'ZN529'}
          ,{value:'ZN530'}
          ,{value:'ZN534'}
          ,{value:'ZN540'}
          ,{value:'ZN543'}
          ,{value:'ZN547'}
          ,{value:'ZN548'}
          ,{value:'ZN549'}
          ,{value:'ZN550'}
          ,{value:'ZN554'}
          ,{value:'ZN557'}
          ,{value:'ZN558'}
          ,{value:'ZN560'}
          ,{value:'ZN561'}
          ,{value:'ZN562'}
          ,{value:'ZN563'}
          ,{value:'ZN564'}
          ,{value:'ZN565'}
          ,{value:'ZN566'}
          ,{value:'ZN567'}
          ,{value:'ZN570'}
          ,{value:'ZN573'}
          ,{value:'ZN574'}
          ,{value:'ZN577'}
          ,{value:'ZN578'}
          ,{value:'ZN580'}
          ,{value:'ZN582'}
          ,{value:'ZN584'}
          ,{value:'ZN586'}
          ,{value:'ZN587'}
          ,{value:'ZN595'}
          ,{value:'ZN605'}
          ,{value:'ZN610'}
          ,{value:'ZN611'}
          ,{value:'ZN613'}
          ,{value:'ZN614'}
          ,{value:'ZN615'}
          ,{value:'ZN616'}
          ,{value:'ZN621'}
          ,{value:'ZN623'}
          ,{value:'ZN626'}
          ,{value:'ZN627'}
          ,{value:'ZN649'}
          ,{value:'ZN652'}
          ,{value:'ZN660'}
          ,{value:'ZN662'}
          ,{value:'ZN664'}
          ,{value:'ZN667'}
          ,{value:'ZN669'}
          ,{value:'ZN671'}
          ,{value:'ZN674'}
          ,{value:'ZN675'}
          ,{value:'ZN677'}
          ,{value:'ZN680'}
          ,{value:'ZN681'}
          ,{value:'ZN682'}
          ,{value:'ZN684'}
          ,{value:'ZN692'}
          ,{value:'ZN701'}
          ,{value:'ZN704'}
          ,{value:'ZN707'}
          ,{value:'ZN708'}
          ,{value:'ZN711'}
          ,{value:'ZN713'}
          ,{value:'ZN714'}
          ,{value:'ZN716'}
          ,{value:'ZN730'}
          ,{value:'ZN736'}
          ,{value:'ZN740'}
          ,{value:'ZN749'}
          ,{value:'ZN75A'}
          ,{value:'ZN75D'}
          ,{value:'ZN765'}
          ,{value:'ZN766'}
          ,{value:'ZN768'}
          ,{value:'ZN770'}
          ,{value:'ZN771'}
          ,{value:'ZN776'}
          ,{value:'ZN778'}
          ,{value:'ZN782'}
          ,{value:'ZN784'}
          ,{value:'ZN787'}
          ,{value:'ZN789'}
          ,{value:'ZN790'}
          ,{value:'ZN791'}
          ,{value:'ZN793'}
          ,{value:'ZN799'}
          ,{value:'ZN805'}
          ,{value:'ZN816'}
          ,{value:'ZN821'}
          ,{value:'ZN823'}
          ,{value:'ZN860'}
          ,{value:'ZN875'}
          ,{value:'ZN879'}
          ,{value:'ZN880'}
          ,{value:'ZN891'}
          ,{value:'ZNF2'}
          ,{value:'ZNF26'}
          ,{value:'ZNF3'}
          ,{value:'ZNF34'}
          ,{value:'ZNF44'}
          ,{value:'ZNF74'}
          ,{value:'ZNF90'}
          ,{value:'ZSA5A'}
          ,{value:'ZSA5C'}
          ,{value:'ZSC16'}
          ,{value:'ZSC21'}
          ,{value:'ZSC22'}
          ,{value:'ZSC23'}
          ,{value:'ZSC29'}
          ,{value:'ZSC31'}
          ,{value:'ZSCA1'}
          ,{value:'ZSCA4'}
      ]
    }
    const handleSelect = (item) => {
      console.log(item)
    }

    const handleAnalysisTypeChange = (value) => {
      // 切换分析类型时清空另一个输入
      if(value === 'tf') {
        form.snv = ''
      } else {
        form.tf = ''
      }
    }

    onMounted(() => {
      restaurants.value = loadAll()
    })

    return {
      ...toRefs(data),
      form,
      onSubmit,
      Example1,
      Example2,
      ReSet,
      querySearch,
      handleSelect,
      handleAnalysisTypeChange
    }
  }
}
</script>

<style scoped>
::v-deep .el-form-item__label{
  font-size: unset;
}
::v-deep .el-form-item__label{
  color: #000000;
}
</style>
